var router = require('pjax').Router;
var roleIndex = require('./index.js');
var form = require('./form.js');

router.get('role', roleIndex);
router.get('role/:any', form);
